<template>
  <div>
    <b-modal
      id="your-contact-modal"
      ref="your-contact-modal-ref"
      hide-footer
      title="Your Contact at Trailfinders"
    >
      <div>
        <b-row>
          <b-col cols="4">
            <b-img
              class=""
              src="https://www.trailfinders.com/codesource/corporate/corp-ipad.png"
              fluid
            />
          </b-col>
          <b-col cols="4">
            <b-img
              class=""
              src="https://www.trailfinders.com/codesource/corporate/corp-logo.png"
              fluid
            />
          </b-col>
          <b-col cols="4">
            <b-img
              class=""
              src="https://www.trailfinders.com/codesource/corporate/corp-right.png"
              fluid
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="7">
            <p>
              Our dedicated corporate team, made up of the most experienced and
              highly trained Travel Consultants pride themselves on taking a
              personalised approach to meet the needs of every client. Typically
              with over 10 years of experience working for Trailfinders, our
              consultants use their expertise to get it right first time, saving
              you hassle and cost.
            </p>
            <p>
              For further information on the full range of services we offer,
              please
              <a
                href="https://www.trailfinders.com/corptravelguidelines.pdf"
                target="_new"
              >
                download our Corporate Travel Handbook </a>. If you would like to discuss your travel policy, please call or
              email us.
            </p>
            <p v-if="!showImage">
              You currently organise your travel with any member of our
              Corporate Travel team. If you would like to have one consultant as
              a dedicated point of contact, please call or email us.
            </p>
          </b-col>
          <b-col cols="5">
            <h6 class="vtd-text-center">
              Your dedicated consultant<span
                v-if="userData.consultants && userData.consultants[1].logname"
              >s</span>
            </h6>

            <div class="vtd-row">
              <div
                v-for="(c, i) in consultants"
                :key="i"
              >
                <div v-if="c.logname">
                  <b-img
                    class=""
                    :src="
                      `https://www.trailfinders.com/staffphotos.nsf/(LULogName)/${c.logname}/$FILE/${c.logname}-lg.jpg`
                    "
                    fluid
                    alt="Consultant"
                  />
                  <h6 class="vtd-text-center">
                    {{ c.fullname }}
                  </h6>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <h5 class="vtd-text-center">
              Please call on 020 7368 1499 or email corporate@trailfinders.com
            </h5>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      userData: "auth/getUserData"
    }),
    consultants() {
      if (!this.userData || !this.userData.consultants) return null;
      return this.userData.consultants.filter(item => item.logname);
    },
    showImage() {
      if (!this.consultants) return null;
      if (this.consultants[this.consultants.length - 1].logname) {
        return true;
      }
      return false;
    }
  },
  methods: {
    show() {
      this.$refs["your-contact-modal-ref"].show();
    }
  }
};
</script>

<style></style>
